import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ClarityIntegration } from "./services/analitica/toolAnalitica.jsx";
import AppRouter from "./AppRouter.jsx";
import { useClarity } from "./services/analitica/useClarity.js";
import ErrorBoundary from "./pages/error-boundary/ErrorBoundary.jsx";
import { useAuth } from "@artprov/design-system";

function App() {
  const { authenticated } = useAuth();
  const { isClarityEnv, clarityId } = useClarity();

  if (!authenticated) {
    return <div>Cargando...</div>;
  }

  return (
    <ErrorBoundary>
      <BrowserRouter>
        {isClarityEnv && <ClarityIntegration projectId={clarityId} />}
        <Routes>
          <Route path="/*" element={<AppRouter />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
